import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { CircularProgress } from "@mui/material";
import { ComponentType, Suspense, lazy } from "react";
import { FieldInputProps } from "react-final-form";

interface EditableCodeEditorProps {
    input: FieldInputProps<any>;
    isDisabled?: boolean;
}

const formFieldFallback = (
    <div style={{ minHeight: 120, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress size={24} />
    </div>
);

const lazyFormField = (
    loader: () => Promise<{ default: ComponentType<FormComponentProps> }>,
    fallback = formFieldFallback
) => {
    const LazyComponent = lazy(loader);

    return (props: FormComponentProps) => (
        <Suspense fallback={fallback}>
            <LazyComponent {...props} />
        </Suspense>
    );
};

export const LazyResizeableCodeEditor = lazyFormField(() =>
    import("components/Form/components/ResizeableCodeEditor/ResizeableCodeEditor").then((module) => ({
        default: module.ResizeableCodeEditor,
    }))
);

export const LazyVisualCodeEditor = lazyFormField(() =>
    import("components/Form/components/VisualCodeEditor/VisualCodeEditor").then((module) => ({
        default: module.VisualCodeEditor,
    }))
);

const LazyEditableCodeEditorComponent = lazy(() =>
    import("components/Form/components/ResizeableCodeEditor/EditableCodeEditor").then((module) => ({
        default: module.EditableCodeEditor,
    }))
);

export const LazyEditableCodeEditor = (props: EditableCodeEditorProps) => (
    <Suspense fallback={formFieldFallback}>
        <LazyEditableCodeEditorComponent {...props} />
    </Suspense>
);
